import { Tooltip } from 'react-tooltip';

export const TopbarButtonsTooltips = () => {
  return (
    <>
      <Tooltip
        anchorSelect="#versions-icon"
        place="bottom"
        content="Versions"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#save-icon"
        place="bottom"
        content="Save"
        delayShow={500}
      />
    </>
  );
};
